import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Portfolio from './pages/Portfolio';
import Login from './pages/Login';
import Panel from './pages/Panel';
import PrivateRoute from './components/PrivateRoute';
import Estudio from './pages/Estudio';
import Importar from './pages/Importar';
import Gratitud from './pages/Gratitud';

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Portfolio />} />
                <Route path="/login" element={<Login />} />
                <Route path="/panel" element={<PrivateRoute><Panel /></PrivateRoute>} />
                <Route path="/panel/estudio" element={<PrivateRoute><Estudio /></PrivateRoute>} />
                <Route path="/panel/importar" element={<PrivateRoute><Importar /></PrivateRoute>} />
                <Route path="/panel/gratitud" element={<PrivateRoute><Gratitud /></PrivateRoute>} />
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
